// Import required modules and types
import { LMFeature, Utils } from "@livingmap/core-mapping";
import { SourceIds } from "../components/Map/plugins/types";

const { createGeoJSONGeometryPoint } = Utils;

const createLMLocationFeature = (coords: string[]): LMFeature => {
  try {
    const geom = createGeoJSONGeometryPoint(coords.map((f) => Number(f)));

    const lmFeature = new LMFeature({
      type: "Feature",
      geometry: geom,
      id: "location-route-pin",
      properties: {
        geom: geom,
        lm_id: "location-route-pin",
        uid: "location-route-pin",
        is_geojson: true,
        geom_type: "DISPLAY_POINT",
        is_label_shown: false,
      },
      layer: {
        id: "custom",
        type: "symbol",
        source: SourceIds.LM_SOURCE_ID,
      },
      state: {},
      source: SourceIds.LM_SOURCE_ID,
    } as any);

    return lmFeature;
  } catch (error) {
    throw new Error(
      "Could not create LMFeature with location data: " +
        (error as Error).message,
    );
  }
};

export default createLMLocationFeature;
